var map = {
	"./checkbox-false.svg": "5Ivo",
	"./checkbox-minus.svg": "Z77G",
	"./checkbox-true.svg": "7kqe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TEyu";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/checkbox\-.*\.svg$
// module id = TEyu
// module chunks = 3